import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerLevelService } from './customer-level.service';

@Component({
  selector: 'app-customer-level',
  templateUrl: './customer-level.component.html',
  styleUrls: ['./customer-level.component.scss']
})
export class CustomerLevelComponent implements OnInit {
  selectedBtn: string = 'sales';
  selectedDi: string = 'All';
  selectedValues: any = {};
  formDetails: any = {};
  salesByTrend: any = {};
  algorithm: any = {};
  baseUrl: string = '/cssna/customerlevel/';
  title: string = 'Customer';
  salesReal: any = {};
  marginReal: any = {};
  dailySales: any = {};
  top5: any = {};
  qParam: any = {};
  dataLoaded: boolean = false;
  reset: number = 0;
  top5Loaded = false;
  detailTiltle: string = '';
  filter: any;
  currentFilter: string = '';
  radio: any;
  lob: string = '';
  salesPercentValTop: any = {};
  salesPercentValBottom: any = {};
  marginPercentValTop: any = {};
  marginPercentValBottom: any = {};
  customerNames: any = {};

  constructor(
    private service: CustomerLevelService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.filter = params['filter'];
      if (this.filter == '') {
        this.lob = 'lob_l1';
      } else {
        this.lob = 'lob_l2';
      }
    });


  }

  private normalizeMulti(value: any): string[] {
    if (!Array.isArray(value) || value.length === 0) return ['All'];
    return value;
  }

  ngOnInit(): void {
    this.selectedValues['engine_model'] = ['All'];
    this.selectedValues['displacement'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['master_customer_name'] = ['All'];
    this.selectedValues['lob_l2'] = ['All'];
    // this.selectedValues['product_bu'] = ['All'];
    this.selectedValues['current_product_bu'] = ['All'];
    this.qParam = {
      displacement: this.normalizeMulti(this.selectedValues.displacement),
      certification: this.normalizeMulti(this.selectedValues.certification),
      master_customer_name: this.normalizeMulti(
        this.selectedValues.master_customer_name
      ),
      engine_model: this.normalizeMulti(this.selectedValues.engine_model),
      lob_l2: this.normalizeMulti(this.selectedValues.lob_l2),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      current_product_bu: this.normalizeMulti(this.selectedValues.current_product_bu),
    };
    this.searchFilters();
    this.getSalesByTrend();
    this.getAlgorithms();
    this.getSalesRealization();
  }
  searchFilters() {

    let displacement = {
      certification: this.selectedValues.certification,
      master_customer_name: this.selectedValues.master_customer_name,
      engine_model: this.selectedValues.engine_model,
      lob_l2: this.selectedValues.lob_l2,
      ecc: this.selectedValues.ecc,
      current_product_bu: this.selectedValues.current_product_bu,
    };
    let certification = {
      displacement: this.selectedValues.displacement,
      master_customer_name: this.selectedValues.master_customer_name,
      engine_model: this.selectedValues.engine_model,
      lob_l2: this.selectedValues.lob_l2,
      ecc: this.selectedValues.ecc,
      current_product_bu: this.selectedValues.current_product_bu,
    };
    let master_customer_name = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      engine_model: this.selectedValues.engine_model,
      lob_l2: this.selectedValues.lob_l2,
      ecc: this.selectedValues.ecc,
      current_product_bu: this.selectedValues.current_product_bu,
    };
    let engine_model = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      master_customer_name: this.selectedValues.master_customer_name,
      lob_l2: this.selectedValues.lob_l2,
      ecc: this.selectedValues.ecc,
      current_product_bu: this.selectedValues.current_product_bu,
    };
    let lob_l2 = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      master_customer_name: this.selectedValues.master_customer_name,
      engine_model: this.selectedValues.engine_model,
      ecc: this.selectedValues.ecc,
      current_product_bu: this.selectedValues.current_product_bu,
    };
    let ecc = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      master_customer_name: this.selectedValues.master_customer_name,
      engine_model: this.selectedValues.engine_model,
      lob_l2: this.selectedValues.lob_l2,
      current_product_bu: this.selectedValues.current_product_bu,
    };
    let ProductBu = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      master_customer_name: this.selectedValues.master_customer_name,
      engine_model: this.selectedValues.engine_model,
      lob_l2: this.selectedValues.lob_l2,
      ecc: this.selectedValues.ecc,
    };

    if (this.currentFilter != 'certification') {
      certification['current_dropdown'] = 'certification';
      this.getDropdowndetails(certification);
    }

    if (this.currentFilter != 'displacement') {
      displacement['current_dropdown'] = 'displacement';
      this.getDropdowndetails(displacement);
    }

    if (this.currentFilter != 'master_customer_name') {
      master_customer_name['current_dropdown'] = 'master_customer_name';
      this.getDropdowndetails(master_customer_name);
    }

    if (this.currentFilter != 'engine_model') {
      engine_model['current_dropdown'] = 'engine_model';
      this.getDropdowndetails(engine_model);
    }
    if (this.currentFilter != 'lob_l2') {
      lob_l2['current_dropdown'] = 'lob_l2';
      this.getDropdowndetails(lob_l2);
    }
    if (this.currentFilter != 'ecc') {
      ecc['current_dropdown'] = 'ecc';
      this.getDropdowndetails(ecc);
    }
    if (this.currentFilter != 'current_product_bu') {
      ProductBu['current_dropdown'] = 'current_product_bu';
      this.getDropdowndetails(ProductBu);
    }
  }
  getDropdowndetails(type) {
    this.service
      .getCustomerDropDown(type, this.baseUrl + 'dropdown')
      .subscribe((results) => {
        let channel: any[] = [];

        if (type.current_dropdown == 'certification')
          channel = results.certification;
        if (type.current_dropdown == 'displacement')
          channel = results.displacement;
        if (type.current_dropdown == 'master_customer_name')
          channel = results.master_customer_name;

        if (type.current_dropdown == 'ecc') channel = results.ecc;

        if (type.current_dropdown == 'engine_model')
          channel = results.engine_model;
        if (type.current_dropdown == 'lob_l2') channel = results.lob_l2;
        if (type.current_dropdown == 'current_product_bu')
          channel = results.current_product_bu;
        const resp = [...new Set(channel)];

        if (type.current_dropdown == 'displacement') {
          this.formDetails['displacement'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'certification') {
          this.formDetails['certification'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'engine_model') {
          this.formDetails['engine_model'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'master_customer_name') {
          this.formDetails['master_customer_name'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'ecc') {
          this.formDetails['ecc'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'lob_l2')
          this.formDetails['lob_l2'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));

        if (type.current_dropdown == 'current_product_bu')
          this.formDetails['current_product_bu'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));

        this.formDetails = { ...this.formDetails };
      });
  }
  searchSalesData(event) {
    this.dataLoaded = false;
    this.currentFilter = event.type;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.qParam = {
      displacement: this.normalizeMulti(this.selectedValues.displacement),
      certification: this.normalizeMulti(this.selectedValues.certification),
      master_customer_name: this.normalizeMulti(
        this.selectedValues.master_customer_name
      ),
      engine_model: this.normalizeMulti(this.selectedValues.engine_model),
      lob_l2: this.normalizeMulti(this.selectedValues.lob_l2),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      current_product_bu: this.normalizeMulti(this.selectedValues.current_product_bu),
    };

    this.searchFilters();
    this.getSalesByTrend();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();

    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.getAlgorithms();

    if (this.selectedDi !== 'All') {
      this.searchDimension(this.selectedDi);
    }
  }
  getAlgorithms() {
    this.dataLoaded = false;
    this.service
      .getAlgorithmsValues(this.qParam, this.baseUrl + 'algorithm' )
      .subscribe((results) => {
        this.algorithm = results;
        this.dataLoaded = true;
      });
  }
  getSalesByTrend() {
    this.salesByTrend = [];
    this.top5Loaded = false;
    this.customerNames = {
      master_customer_name: this.normalizeMulti(this.selectedValues.master_customer_name),
    };
    this.service
      .getSalesByTrendBridgeValues(this.customerNames, this.baseUrl + 'salestrend')
      .subscribe((results) => {
        this.salesByTrend = results;
        this.top5Loaded = true;
      });
  }
  getSalesRealization() {
    this.salesReal = [];
    this.dataLoaded = false;

    this.service
      .getSalesBridgeValues(this.qParam, this.baseUrl + 'salesrealisation')
       
      .subscribe((results) => {
        this.salesReal = results;
        this.dataLoaded = true;
      });

    this.service.getSalesPercentageVal(this.qParam, this.baseUrl + 'salesrealisation/percentage/top').subscribe((res) => {
      this.salesPercentValTop = res;
      this.dataLoaded = true;
    })
    this.service.getSalesPercentageVal(this.qParam, this.baseUrl + 'salesrealisation/percentage').subscribe((res) => {
      this.salesPercentValBottom = res;
      this.dataLoaded = true;
    })

  }


  getMarginRealization() {
    this.marginReal = [];
    this.dataLoaded = false;
    this.service.getMarginBrigeValues(this.qParam, this.baseUrl + 'marginrealisation')
      .subscribe((results) => {
        this.marginReal = results;
        this.dataLoaded = true;
      });

    // this.service.getMarginPercentValues(this.qParam, this.baseUrl + 'marginrealisation/percentage/top')
    //   .subscribe((responese) => {
    //     this.marginPercentValTop = responese;
    //     this.dataLoaded = true;
    //   })
    // this.service.getMarginPercentValues(this.qParam, this.baseUrl + 'marginrealisation/percentage')
    //   .subscribe((responese) => {
    //     this.marginPercentValBottom = responese;
    //     this.dataLoaded = true;
    //   })
  }

  salesButton() {
    this.selectedBtn = 'sales';
    this.getSalesRealization();

  }
  marginButton() {
    this.selectedBtn = 'margin';
    this.getMarginRealization();
  }

  byTrend() {
    this.selectedDi = 'All';
    this.qParam.lob_l2 = ['All'];
    this.getSalesByTrend();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();

    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.radio = null;
  }
  searchDimension(event) {
    this.qParam = {
      displacement: this.normalizeMulti(this.selectedValues.displacement),
      certification: this.normalizeMulti(this.selectedValues.certification),
      master_customer_name: this.normalizeMulti(
        this.selectedValues.master_customer_name
      ),
      engine_model: this.normalizeMulti(this.selectedValues.engine_model),
      lob_l2: this.normalizeMulti(this.selectedValues.lob_l2),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      current_product_bu: this.normalizeMulti(this.selectedValues.current_product_bu),
    };
    this.selectedDi = event;
    this.top5Loaded = false;

    this.top5 = [];
    this.service
      .getTop5Values(this.qParam, this.baseUrl + 'sales/top5/' + event )
      .subscribe((results) => {
        this.top5 = results;
        this.top5Loaded = true;
      });
  }

  resetFilter() {
    this.reset = this.reset + 1;
    this.qParam = {
      displacement: ['All'],
      certification: ['All'],
      master_customer_name: ['All'],
      engine_model: ['All'],
      lob_l2: ['All'],
      ecc: ['All'],
      current_product_bu: ['All'],
    };
    this.selectedValues['engine_model'] = ['All'];
    this.selectedValues['displacement'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['master_customer_name'] = ['All'];
    this.selectedValues['lob_l2'] = ['All'];
    this.selectedValues['current_product_bu'] = ['All'];

    this.currentFilter = '';
    this.searchFilters();
    this.byTrend();
    this.getAlgorithms();
  }


}
